export const getHeroImageDetail = (item, isWebDesktopScreen) =>
  isWebDesktopScreen && item.heroImageWeb ? item.heroImageWeb : item.heroImage;
